import { render, staticRenderFns } from "./question-row-component.vue?vue&type=template&id=6fa22a8e&scoped=true"
import script from "./question-row-component.vue?vue&type=script&lang=js"
export * from "./question-row-component.vue?vue&type=script&lang=js"
import style0 from "./question-row-component.vue?vue&type=style&index=0&id=6fa22a8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa22a8e",
  null
  
)

export default component.exports